module.exports = __webpack_public_path__ + "img/bole.46d37951.png";